export class ScanProduct{
 sku: string = '';
 name: string = '';
 serial: string = '';
 batchNumber: string = ''
 companyId: number = 0;
}
